<div class="read-more">
  <div class="container lucid-width">
    <lib-heading heading="Who We Are" [lucid]="true" subheading="AgingPlan">
      <p></p>
    </lib-heading>

    <p>
      Founded in 1988, our sole focus is, and always has been, Long-Term Care planning. Because we are committed to this one area of focus, we are able to offer a level of service and expertise that
      is unique. We strive to be the best at what we do. Since Long-Term Care Planning is ALL we do, we are able to invest all of our energy in to this goal.
    </p>

    <p>
      We also strive to be holistic in our perspective, while recognizing both the financial and emotional impacts of a Long-Term Care event. We realize that many of the individuals who proactively
      plan for a Long-Term Care event do so because they have witnessed such an event or have been intimately involved in a Long-Term Care event as a caregiver. It is these individuals who understand
      the impact of such an event on a family.
    </p>

    <h3>What Makes Us Unique?</h3>

    <p>
      Our longevity and specialty in the Long-Term Care Insurance market has enhanced our depth of understanding in this market, from the carriers that offer insurance product solutions to the needs
      of families at the time of a care need. We have the knowledge and experience to assist clients in making appropriate and well-thought-out planning decisions.
    </p>

    <p>
      We have developed a business model in which we analyze and assess multiple options within most every major insurance company in the LTCI brokerage market. This allows us to guide our clients
      through a selection process that is designed to give them the most choices, while at the same time depending on our breadth of experience to evaluate each insurance carrier, their financial
      strength, their plan designs, and their position in the Long-Term Care Insurance market.
    </p>

    <h3>We believe that Long-Term Care Insurance is a tool</h3>

    <p>
      Tools have appropriate uses, and it is important to assess if Long-Term Care Insurance is a tool that is appropriate for a specific individual or family. Long-Term Care Insurance is not for
      everyone. Its implementation can provide significant financial protection, leveraging and liquidity. However, it is a tool to be applied, not just a product to be sold. We are committed to sound
      financial integration of this product when it is beneficial to the client. It is the evaluation of options and the integration of insurance planning tools where appropriate that bring a distinct
      flavor to the business we live and practice.
    </p>

    <h3>We Believe in Claims Advocacy</h3>
    <p>
      We aim to be the best resource for both the purchase of Long-Term Care insurance protection as well as its utilization. When it comes time to exercise the benefits of these policies, we believe
      consumers need advocates to help them navigate a claim. Unfortunately, most are left with an 800# to a Claims Department when they are physically or cognitively frail.
    </p>

    <p>
      Advocacy is about defending those who might be vulnerable in their time of need. (See Senior Sabatoge) Many distributors of this product will claim to be able to assist at the time of a care
      need. However, few have the level of experience and number of clients to fulfill this role. We provide a unique service in this way. When a family is in crisis, they need someone to be their
      advocate. At AgingPlan we believe our job is to be that family’s advocate with their insurer.
    </p>

    <h3>How We Work</h3>
    <p>
      A large portion of our clients are referred to us by financial advisors (as well as other tax and legal advisors). Financial advisors, in particular, understand risk management and insurance
      leveraging tools. They also see the direct results to their clients’ financial plans when the Long-Term Care risk is planned for in both a well-thought-out way as well as when it is done poorly.
      The fact that many of our clients find us through their financial advisor is a testament to our commitment to sound planning for this potentially disruptive or catastrophic financial event.
    </p>
  </div>
</div>
